import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";

var genStatusStyle = function genStatusStyle(token) {
  var componentCls = token.componentCls,
      menuCls = token.menuCls,
      colorError = token.colorError,
      colorTextLightSolid = token.colorTextLightSolid;
  var itemCls = "".concat(menuCls, "-item");
  return _defineProperty({}, "".concat(componentCls, ", ").concat(componentCls, "-menu-submenu"), _defineProperty({}, "".concat(menuCls, " ").concat(itemCls), _defineProperty({}, "&".concat(itemCls, "-danger:not(").concat(itemCls, "-disabled)"), {
    color: colorError,
    '&:hover': {
      color: colorTextLightSolid,
      backgroundColor: colorError
    }
  })));
};

export default genStatusStyle;